module.exports = __webpack_public_path__ + "fonts/fontello.6c52756.eot";